import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ApiHeadersInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // eslint-disable-next-line no-param-reassign
    request = request.clone({
      setHeaders: {
        fehost: location.hostname,
        feschema: location.protocol.replace(':', ''),
        feport: (
          location.port || (location.protocol.includes('https') ? 443 : 80)
        ).toString(),
      },
    });

    return next.handle(request);
  }
}
